/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Nav_DietInputs */

const en_hub_nav_diet = /** @type {(inputs: Hub_Nav_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet`)
};

const pl_hub_nav_diet = /** @type {(inputs: Hub_Nav_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta`)
};

/**
* | output |
* | --- |
* | "Diet" |
*
* @param {Hub_Nav_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hub_nav_diet = /** @type {((inputs?: Hub_Nav_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Nav_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hub_nav_diet(inputs)
	return en_hub_nav_diet(inputs)
});